import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedMail = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.91683 39.5834C6.82829 39.5834 5.89643 39.1958 5.12126 38.4207C4.34608 37.6455 3.9585 36.7136 3.9585 35.6251V11.8751C3.9585 10.7865 4.34608 9.85468 5.12126 9.07951C5.89643 8.30433 6.82829 7.91675 7.91683 7.91675H39.5835C40.672 7.91675 41.6039 8.30433 42.3791 9.07951C43.1542 9.85468 43.5418 10.7865 43.5418 11.8751V35.6251C43.5418 36.7136 43.1542 37.6455 42.3791 38.4207C41.6039 39.1958 40.672 39.5834 39.5835 39.5834H7.91683ZM23.7502 25.7292L39.5835 15.8334V11.8751L23.7502 21.7709L7.91683 11.8751V15.8334L23.7502 25.7292Z",
		fill: "url(#paint0_linear_1067_2713)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_1067_2713",
		x1: 3.75021,
		y1: 40.0001,
		x2: 43.7502,
		y2: 7.50011,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#142F95" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#2563EB"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CACBFF"
			})
		]
	}) })]
});
export default SvgExtendedMail;
